/**
 * Central source-of-truth for all registered keyboard shortcuts.
 * Components consume this list to render the cheatsheet; hooks wire each
 * `keys` string to its `action` via useGlobalShortcut.
 */

export type ShortcutGroup = "navigation" | "global" | "editing";

export interface ShortcutEntry {
  id: string;
  /** react-hotkeys-hook key combo string */
  keys: string;
  /** i18n key under keyboard_shortcuts.* for the label */
  labelKey: string;
  /** Display-friendly key chips, e.g. ["?"] or ["cmd", "k"] */
  displayKeys: string[];
  group: ShortcutGroup;
}

export const SHORTCUT_REGISTRY: ShortcutEntry[] = [
  {
    id: "open-cheatsheet",
    keys: "shift+slash",
    labelKey: "open_cheatsheet",
    displayKeys: ["?"],
    group: "global",
  },
  {
    id: "command-palette",
    keys: "mod+k",
    labelKey: "command_palette",
    displayKeys: ["⌘", "K"],
    group: "global",
  },
];
